module.exports = __webpack_public_path__ + "static/media/PATS_1-223w.c531f82e.webp";